import { render, staticRenderFns } from "./JournalStats.vue?vue&type=template&id=6ba621be&scoped=true"
import script from "./JournalStats.vue?vue&type=script&lang=js"
export * from "./JournalStats.vue?vue&type=script&lang=js"
import style0 from "./JournalStats.vue?vue&type=style&index=0&id=6ba621be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba621be",
  null
  
)

export default component.exports